import { render, staticRenderFns } from "./appointment-success.vue?vue&type=template&id=1a836195&scoped=true"
import script from "./appointment-success.vue?vue&type=script&lang=js"
export * from "./appointment-success.vue?vue&type=script&lang=js"
import style0 from "./appointment-success.vue?vue&type=style&index=0&id=1a836195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a836195",
  null
  
)

export default component.exports